// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[type=checkbox][data-v-64cb9979],input[type=radio][data-v-64cb9979]{width:15px;height:15px}", ""]);
// Exports
module.exports = exports;
